<template>
    <component
        :is="element"
        class="base-tag"
    >
        <slot />
    </component>
</template>

<script setup>
defineProps({
    element: {
        type: [String, Object],
        default: 'div'
    }
});
</script>

<style src="./BaseTag.less" lang="less"></style>
